import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import bannerImgEn from '../../img/drag_n_drop_en.gif';
import bannerImgKr from '../../img/drag_n_drop_kr.gif';
import addFavoriteIcon from '../../img/ico_add_favorite.png';
import addFavoriteIcon2X from '../../img/ico_add_favorite@2x.png';
import newsIcon from '../../img/ico_news.png';
import newsIcon2X from '../../img/ico_news@2x.png';
import guideIcon from '../../img/ico_guide.png';
import guideIcon2X from '../../img/ico_guide@2x.png';
import shortcutIcon from '../../img/ico_shortcut.png';
import shortcutIcon2X from '../../img/ico_shortcut@2x.png';
import feedbackIcon from '../../img/ico_feedback.png';
import feedbackIcon2X from '../../img/ico_feedback@2x.png';
import bgBlur from '../../img/ad_bg_blur.png';
import bgBlur2X from '../../img/ad_bg_blur@2x.png';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  DIALOG_TYPE,
  DOC_FORMAT_CONFIG_VALUES,
  LANGUAGE,
  PRODUCT_TYPE,
  URLS
} from '../../define/global';
import { openDialog } from '../../store/modules/dialog';
import ga from '../../utils/gaConnect';
import FixedAD, { FIXED_AD_ID } from '../common/FixedAD';
import { CustomScrollbar } from '../common/CssCommon';
import { getLanguage } from '../../utils/util';
import UpdateNotification from './UpdateNotification';
import { useAppDataSliceSelector } from '../../store/modules/appData';
//import SliderBanner from '../SliderBanner';

const MenuInfoBody = styled.div`
  width: 504px;
  height: 100%;
  border-left: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding-right: 5px;
  padding-left: 5px;
  align-items: center;
`;

const CustomDotsStyle = css`
  position: absolute;
  height: fit-content;
  bottom: 10px;
  left: 0px;
`;

const MenuInfoContainer = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 70px;
  ${CustomScrollbar};

  & .customdotsstyle {
    ${CustomDotsStyle}
  }
`;

const Banner = styled.img`
  width: 468px;
  height: 208px;
  margin: 10px 13px 30px 13px;
  &:hover {
    cursor: pointer;
  }
`;

const GuideMenuWapper = styled.ul`
  margin: 0;
  display: flex;
  margin-block-start: 0;
  margin-block-end: 0;
  padding-inline-start: 0;
  list-style-type: none;
  width: 100%;
  height: 78px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
  padding: 0 18px;
  box-sizing: border-box;
`;
const GuideMenuItem = styled.li`
  width: 84px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &:hover {
    background: #f7f7f7;
    cursor: pointer;
  }
  &:active {
    background: #f0f0f0;
    cursor: pointer;
  }
`;

const GuideMenuItemIcon = styled.img`
  width: 48px;
  height: 48px;
`;

const GuideMenuItemName = styled.p`
  margin: 0;
  font-family: MalgunGothic;
  font-size: 12px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #2f3133;
`;

const Update = styled.div`
  width: 100%;
  padding: 0 28px;
  box-sizing: border-box;
  flex: 1;
  min-height: 130px;
`;

const ADWrapper = styled.div`
  width: 100%;
  height: 69px;
  margin-top: 13px;
  margin-bottom: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const UpdateListBlur = styled.img`
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 48px;
`;

const Copyright = styled.div`
  width: 100%;
  font-size: 11px;
  color: #a1a1a1;
  padding: 0px 18px;
  box-sizing: border-box;
`;

function FileMenuInfo() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const appDataSlice = useAppDataSliceSelector();
  const isB2C =
    appDataSlice.productType !== PRODUCT_TYPE.WITH_WHALE_SPACE &&
    appDataSlice.productType !== PRODUCT_TYPE.WITH_URL_OPENER_B2B;

  const docType = DOC_FORMAT_CONFIG_VALUES.sdk.documnetType;

  const getBannerLink = useCallback(() => {
    const hostsplited = window.location.hostname.split('.');
    if (hostsplited.length === 3) {
      switch (hostsplited[0]) {
        case 'vf-webeditor':
        case 'vf-websheet':
        case 'vf-webslide':
          return URLS.EDITOR._SHEET_DEV;
        case 'hwp':
          return `${URLS.EDITOR.SHEET}?utm_source=poweb&utm_medium=banner_hwp&utm_campaign=addsheet`;
        case 'sheet':
          return `${URLS.EDITOR.SHEET}?utm_source=poweb&utm_medium=banner_sheet&utm_campaign=addsheet`;
        case 'slide':
          return `${URLS.EDITOR.SHEET}?utm_source=poweb&utm_medium=banner_slide&utm_campaign=addsheet`;
        default:
          break;
      }
    }
    return URLS.EDITOR.SHEET;
  }, []);
  const bannerLink = getBannerLink();

  const onClickBanner = useCallback(() => {
    ga.event({ category: '파일탭', action: '배너' });
    window.open(bannerLink, '_blank', 'noopener,noreferrer');
  }, []);

  const onClickAddFavorite = useCallback(() => {
    ga.event({ category: '파일탭', action: '즐겨찾기추가' });
    dispatch(openDialog({ dialogType: DIALOG_TYPE.DIALOG_ADD_FAVORITE }));
  }, []);

  const onClickFeedback = useCallback(() => {
    let url = '';
    if (isB2C) {
      ga.event({ category: '기타기능', action: '고객지원' });
      url =
        getLanguage(i18n.language) === LANGUAGE.KO
          ? URLS.CUSTOMERSUPPORT.KO[docType.toUpperCase()]
          : URLS.CUSTOMERSUPPORT.EN[docType.toUpperCase()];
    } else {
      ga.event({ category: '기타기능', action: '피드백 및 제안' });
      url =
        getLanguage(i18n.language) === LANGUAGE.KO
          ? URLS.FEEDBACK.STANDALONE.KO
          : URLS.FEEDBACK.STANDALONE.EN;
    }

    window.open(url, '_blank', 'noopener,noreferrer');
  }, [isB2C]);

  const onSendNotice = useCallback(() => {
    ga.event({ category: '기타기능', action: '새소식' });
    window.open(URLS.NOTION.HOME, '_blank', 'noopener,noreferrer');
  }, []);

  const onClickUserGuide = useCallback(() => {
    //ga.event({ category: '기타기능', action: '새소식' });
    const url = URLS.NOTION.USER_GUIDE[docType.toUpperCase()];
    window.open(url, '_blank', 'noopener,noreferrer');
  }, []);

  const onClickShortcutGuide = useCallback(() => {
    //ga.event({ category: '기타기능', action: '새소식' });
    const url = URLS.NOTION.SHORTCUT[docType.toUpperCase()];
    window.open(url, '_blank', 'noopener,noreferrer');
  }, []);

  const bannerImg = getLanguage(i18n.language) === LANGUAGE.KO ? bannerImgKr : bannerImgEn;

  return (
    <MenuInfoBody>
      <MenuInfoContainer>
        <Banner src={bannerImg} onClick={onClickBanner} />
        {/* <SliderBanner /> */}
        <GuideMenuWapper>
          <GuideMenuItem onClick={onClickAddFavorite}>
            <GuideMenuItemIcon src={addFavoriteIcon} srcSet={addFavoriteIcon2X} />
            <GuideMenuItemName>{t('FileMenu.AddFavorite')}</GuideMenuItemName>
          </GuideMenuItem>
          <GuideMenuItem onClick={onSendNotice}>
            <GuideMenuItemIcon src={newsIcon} srcSet={newsIcon2X} />
            <GuideMenuItemName>{t('FileMenu.News')}</GuideMenuItemName>
          </GuideMenuItem>
          <GuideMenuItem onClick={onClickUserGuide}>
            <GuideMenuItemIcon src={guideIcon} srcSet={guideIcon2X} />
            <GuideMenuItemName>{t('FileMenu.Guide')}</GuideMenuItemName>
          </GuideMenuItem>
          <GuideMenuItem onClick={onClickShortcutGuide}>
            <GuideMenuItemIcon src={shortcutIcon} srcSet={shortcutIcon2X} />
            <GuideMenuItemName>{t('FileMenu.ShortCut')}</GuideMenuItemName>
          </GuideMenuItem>
          <GuideMenuItem onClick={onClickFeedback}>
            <GuideMenuItemIcon src={feedbackIcon} srcSet={feedbackIcon2X} />
            <GuideMenuItemName>
              {isB2C ? t('FileMenu.CustomerSupport') : t('FileMenu.Feedback')}
            </GuideMenuItemName>
          </GuideMenuItem>
        </GuideMenuWapper>
        <Update>
          <UpdateNotification />
        </Update>
        <UpdateListBlur src={bgBlur} srcSet={bgBlur2X} />
      </MenuInfoContainer>
      {isB2C && <Copyright>{t('FileMenu.Copyright')}</Copyright>}
      <ADWrapper>
        <FixedAD id={FIXED_AD_ID.IN_FILEMENU}></FixedAD>
      </ADWrapper>
    </MenuInfoBody>
  );
}

export default FileMenuInfo;
